import { format } from "date-fns";
import { createMarkup } from "../../../utils";

export const COLUMNS = [
  {
    Header: "Employee Id",
    accessor: "EmployeeId"
  },
  {
    Header: "Last Name",
    accessor: "EmployeeLastName",
    id: "EmployeeLastName"
  },
  {
    Header: "First Name",
    accessor: "EmployeeFirstName",
    id: "EmployeeFirstName"
  },
  {
    Header: "Employee Type",
    accessor: "EmployeeType",
    id: "EmployeeType"
  },
  {
    Header: "Type",
    accessor: "CertificationType",
    id: "CertificationType"
  },
  {
    Header: "Last Test Date",
    accessor: "LastTestDate",
    id: "LastTestDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Expiration Date",
    accessor: "ExpirationDate",
    ExpirationDate: "ExpirationDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Days To Expire",
    accessor: "DaysToExpire",
    Cell: ({ cell }) => cell.value,
    id: "DaysToExpire"
  },
  {
    Header: "Note",
    accessor: "Note",
    id: "Note",
    Cell: ({ cell }) => createMarkup(cell.value)
  }
];
